<template>
  <div class="home" :style="{ minHeight: bodyHeight + 'px' }">
    <!-- <gSwiper :arr="arr2" :maxH="'inherit'" v-if="showImg"></gSwiper>
    <gSwiper :arr="arr" :maxH="'inherit'" v-else></gSwiper> -->
    <router-view></router-view>
    <div class="copyright">© 2015-{{ new Date().getFullYear() }} Bakery China Exhibitions Co., Ltd. </div>
  </div>
</template>

<script>

import gSwiper from "@components/gSwiper/gSwiper2.vue";
export default {
  name: 'ex-register',
  components: {
    gSwiper,
  },
  props: {},
  data () {
    return {
      arr: [{ id: 1, path: 'https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202206/a7277d5fc25b44dba32f48444ff0624f.png' }],
      //   arr2: [{ id: 1, path: 'https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202209/f58c7413f8f140f3a66279c46beb518b.jpeg' }],
      arr2: [{ id: 1, path: 'https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202405/8da3d6709bec47559933f9446490f460.jpg' }],
      bodyHeight: "800px",
    };
  },
  watch: {},
  computed: {
    showImg () {
      let now = new Date().getTime();
      let endTime = new Date('2022/9/19').getTime();

      return now > endTime;
    }
  },
  methods: {},
  created () {
    this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
  },
  mounted () {
  }
}

</script>

<style lang="scss" scoped>
.home {
  background: #fff;
}

.copyright {
  margin: 0 auto;
  padding-bottom: 64px;
  text-align: center;
  font-size: 12px;
  color: #999;
  padding: 0 20px 30px;
}
</style>
